import React from 'react'
import { BsTwitter, BsInstagram, BsLinkedin, BsGithub, BsYoutube, BsTelegram } from 'react-icons/bs'
import { FaFacebookF, FaTiktok } from 'react-icons/fa'

const SocialMedia = () => {
  return (
    <div  className='app__social'>
      <div>
        <a href="https://www.linkedin.com/in/emmanuella-ubokabasi-etop-essien-b41846227/" target='_blank' rel="noreferrer" >
          <BsLinkedin />          
        </a>
      </div>
      <div>
       <a href="https://www.youtube.com/@ubcodes/videos" target='_blank'  rel="noreferrer" >
         <BsYoutube />
       </a>
      </div>
      <div>
       <a href="https://github.com/ubocodes" target='_blank' rel="noreferrer" >
         <BsGithub />
       </a>
      </div>
      <div>
        <a href="https://t.me/ubcodestelegramchannel" target='_blank' rel="noreferrer" >
          <BsTelegram/>
        </a>
      </div>
      <div>
        <a href="https://www.instagram.com/ubcodes._/" target='_blank' rel="noreferrer" >
          <BsInstagram />
        </a>
      </div>
      <div>
       <a href="https://twitter.com/ubcodes1_" target='_blank' rel="noreferrer" >
         <BsTwitter />
       </a>
      </div>
      <div>
        <a href="https://www.tiktok.com/@ubcodes_"  target='_blank' rel="noreferrer" >
          <FaTiktok/>
        </a>
      </div>
      <div>
        <a href="https://www.facebook.com/emmanuella.etopessien.5/" target='_blank' rel="noreferrer">
          <FaFacebookF />
        </a>
      </div>
    </div>
  )
}

export default SocialMedia
